import { useContext } from 'react';

import { ProctoringRegistrationDetailsContext } from './proctoring-registration-details-provider';

function useProctoringRegistrationDetails() {
  const context = useContext(ProctoringRegistrationDetailsContext);

  if (!context) {
    throw new Error(
      'function useRegistrationDetails must be used within a ProctoringRegistrationDetailProvider',
    );
  }

  return context;
}

export { useProctoringRegistrationDetails };
